export interface TrucksInAreaDTO {
  count: number;
  transport_ids: string[];
  last_updated: string;
}

export interface UnloadingPointAverageDlzDTO {
  unloading_point: string;
  average_dlz: number;
}

export interface UnloadingPointsAverageDlzInfoDTO {
  metric: string;
  last_updated: string;
  unloading_points: UnloadingPointAverageDlzDTO[];
}

export interface TrucksInPointInfoDTO {
  point: string;
  count: number;
  transport_ids: string[];
}

export interface TrucksInPlantByPointInfoDTO {
  total_points: number;
  data: TrucksInPointInfoDTO[];
}

export class TrucksInAreaListDTO {
  constructor(public data: TrucksInAreaDTO) {}
}

export class TrucksInAreaParkingListDTO {
  constructor(public data: TrucksInAreaDTO) {}
}

export class UnloadingPointsAverageDlzInfoListDTO {
  constructor(public data: UnloadingPointsAverageDlzInfoDTO) {}
}

export class TrucksInPlantByPointInfoListDTO {
  constructor(public data: TrucksInPlantByPointInfoDTO) {}
}
